/**
 * Judge's Gallery component
*/
import { createApp } from 'vue';
import { createWebHashHistory, createRouter } from 'vue-router'
// import { fullscreenImagePlugin } from 'vue-3-fullscreen-image-directive-plugin'
// import 'vue-3-fullscreen-image-directive-plugin/style.css'
import { fullscreenImagePlugin } from 'vue-3-fullscreen-image-directive-plugin'

import VueEasyLightbox from 'vue-easy-lightbox'
import 'vue-easy-lightbox/external-css/vue-easy-lightbox.css'


import routes from './judge-gallery-routes.js';
import store from './store/store.js';
import App from './components/JudgeGalleryApp.vue';

const router = createRouter({
	history: createWebHashHistory(),
	routes,
});

// set user id
store.commit('setUserId', window.ff_settings.current_user_id || 0);
store.commit('setNonce', window.ff_settings.token || 0);
store.commit('setLoginPage', window.ff_settings.login_page || '');

const judgeGalleryApp = createApp(App)
							.use(store)
							.use(router)
							// .use(fullscreenImagePlugin)
							.use(VueEasyLightbox)
							.mount('#judge-gallery');